export const CubesBg75Svg = (props: React.SVGProps<SVGSVGElement>) => (
  <svg fill="none" viewBox="0 0 949 1219" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#mv)">
      <rect transform="matrix(.86602 .5 -.86602 .5 536.2 748.82)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#io)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 583.81 693.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#eh)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 498.24 726.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#bo)">
      <rect transform="matrix(.86602 .5 -.86602 .5 537.2 874.82)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#bd)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 584.81 819.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#as)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 499.24 852.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#ah)">
      <rect transform="matrix(.86602 .5 -.86602 .5 501.2 937.82)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#w)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 548.81 882.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#l)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 463.24 915.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#a)">
      <rect transform="matrix(.86602 .5 -.86602 .5 537.2 1000.8)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#mk)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 584.81 945.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#lz)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 499.24 978.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#lo)">
      <rect transform="matrix(.86602 .5 -.86602 .5 501.2 1063.8)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#ld)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 548.81 1008.1)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#ks)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 463.24 1041.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#kh)">
      <rect transform="matrix(.86602 .5 -.86602 .5 538.2 1126.8)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#jw)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 585.81 1071.1)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#jl)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 500.24 1104.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#ja)">
      <rect transform="matrix(.86602 .5 -.86602 .5 573.2 811.82)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#ip)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 620.81 756.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#id)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 535.24 789.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#hs)">
      <rect transform="matrix(.86602 .5 -.86602 .5 609.2 748.82)" width="67.733" height="120.43" fill="#047BFF" />
    </g>
    <g clipPath="url(#hh)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 656.81 693.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#gw)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 571.24 726.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#gl)">
      <rect transform="matrix(.86602 .5 -.86602 .5 610.2 874.82)" width="67.733" height="120.43" fill="#047BFF" />
    </g>
    <g clipPath="url(#ga)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 657.81 819.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#fp)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 572.24 852.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#fe)">
      <rect transform="matrix(.86602 .5 -.86602 .5 574.2 937.82)" width="67.733" height="120.43" fill="#047BFF" />
    </g>
    <g clipPath="url(#et)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 621.81 882.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#ei)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 536.24 915.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#dw)">
      <rect transform="matrix(.86602 .5 -.86602 .5 610.2 1000.8)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#dl)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 657.81 945.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#da)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 572.24 978.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#cp)">
      <rect transform="matrix(.86602 .5 -.86602 .5 574.2 1063.8)" width="67.733" height="120.43" fill="#047BFF" />
    </g>
    <g clipPath="url(#ce)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 621.81 1008.1)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#bt)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 536.24 1041.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#bs)">
      <rect transform="matrix(.86602 .5 -.86602 .5 611.2 1126.8)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#br)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 658.81 1071.1)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#bq)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 573.24 1104.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#bp)">
      <rect transform="matrix(.86602 .5 -.86602 .5 646.2 811.82)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#bn)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 693.81 756.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#bm)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 608.24 789.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#bl)">
      <rect transform="matrix(.86602 .5 -.86602 .5 682.2 748.82)" width="67.733" height="120.43" fill="#047BFF" />
    </g>
    <g clipPath="url(#bk)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 729.81 693.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#bj)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 644.24 726.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#bi)">
      <rect transform="matrix(.86602 .5 -.86602 .5 683.2 874.82)" width="67.733" height="120.43" fill="#047BFF" />
    </g>
    <g clipPath="url(#bh)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 730.81 819.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#bg)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 645.24 852.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#bf)">
      <rect transform="matrix(.86602 .5 -.86602 .5 647.2 937.82)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#be)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 694.81 882.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#bc)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 609.24 915.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#bb)">
      <rect transform="matrix(.86602 .5 -.86602 .5 683.2 1000.8)" width="67.733" height="120.43" fill="#047BFF" />
    </g>
    <g clipPath="url(#ba)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 730.81 945.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#az)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 645.24 978.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#ay)">
      <rect transform="matrix(.86602 .5 -.86602 .5 647.2 1063.8)" width="67.733" height="120.43" fill="#047BFF" />
    </g>
    <g clipPath="url(#ax)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 694.81 1008.1)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#aw)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 609.24 1041.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#av)">
      <rect transform="matrix(.86602 .5 -.86602 .5 719.2 811.82)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#au)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 766.81 756.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#at)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 681.24 789.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#ar)">
      <rect transform="matrix(.86602 .5 -.86602 .5 755.2 748.82)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#aq)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 802.81 693.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#ap)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 717.24 726.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#ao)">
      <rect transform="matrix(.86602 .5 -.86602 .5 756.2 874.82)" width="67.733" height="120.43" fill="#047BFF" />
    </g>
    <g clipPath="url(#an)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 803.81 819.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#am)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 718.24 852.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#al)">
      <rect transform="matrix(.86602 .5 -.86602 .5 720.2 937.82)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#ak)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 767.81 882.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#aj)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 682.24 915.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#ai)">
      <rect transform="matrix(.86602 .5 -.86602 .5 756.2 1000.8)" width="67.733" height="120.43" fill="#047BFF" />
    </g>
    <g clipPath="url(#ag)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 803.81 945.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#af)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 718.24 978.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#ae)">
      <rect transform="matrix(.86602 .5 -.86602 .5 720.2 1063.8)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#ad)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 767.81 1008.1)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#ac)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 682.24 1041.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#ab)">
      <rect transform="matrix(.86602 .5 -.86602 .5 792.2 811.82)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#aa)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 839.81 756.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#z)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 754.24 789.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#y)">
      <rect transform="matrix(.86602 .5 -.86602 .5 828.2 748.82)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#x)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 875.81 693.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#v)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 790.24 726.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#u)">
      <rect transform="matrix(.86602 .5 -.86602 .5 829.2 874.82)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#t)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 876.81 819.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#s)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 791.24 852.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#r)">
      <rect transform="matrix(.86602 .5 -.86602 .5 793.2 937.82)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#q)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 840.81 882.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#p)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 755.24 915.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#o)">
      <rect transform="matrix(.86602 .5 -.86602 .5 829.2 1000.8)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#n)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 876.81 945.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#m)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 791.24 978.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#k)">
      <rect transform="matrix(.86602 .5 -.86602 .5 793.2 1063.8)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#j)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 840.81 1008.1)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#i)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 755.24 1041.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#h)">
      <rect transform="matrix(.86602 .5 -.86602 .5 755.2 -7.1798)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#g)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 802.81 -62.877)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#f)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 717.24 -29.096)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#e)">
      <rect transform="matrix(.86602 .5 -.86602 .5 719.2 55.82)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#d)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 766.81 .12341)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#c)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 681.24 33.904)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#b)">
      <rect transform="matrix(.86602 .5 -.86602 .5 756.2 118.82)" width="67.733" height="120.43" fill="#047BFF" />
    </g>
    <g clipPath="url(#mu)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 803.81 63.123)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#mt)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 718.24 96.904)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#ms)">
      <rect transform="matrix(.86602 .5 -.86602 .5 720.2 181.82)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#mr)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 767.81 126.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#mq)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 682.24 159.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#mp)">
      <rect transform="matrix(.86602 .5 -.86602 .5 683.2 244.82)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#mo)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 730.81 189.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#mn)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 645.24 222.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#mm)">
      <rect transform="matrix(.86602 .5 -.86602 .5 646.2 307.82)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#ml)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 693.81 252.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#mj)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 608.24 285.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#mi)">
      <rect transform="matrix(.86602 .5 -.86602 .5 610.2 244.82)" width="67.733" height="120.43" fill="#047BFF" />
    </g>
    <g clipPath="url(#mh)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 657.81 189.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#mg)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 572.24 222.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#mf)">
      <rect transform="matrix(.86602 .5 -.86602 .5 574.2 307.82)" width="67.733" height="120.43" fill="#047BFF" />
    </g>
    <g clipPath="url(#me)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 621.81 252.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#md)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 536.24 285.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#mc)">
      <rect transform="matrix(.86602 .5 -.86602 .5 574.2 181.82)" width="67.733" height="120.43" fill="#047BFF" />
    </g>
    <g clipPath="url(#mb)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 621.81 126.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#ma)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 536.24 159.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#ly)">
      <rect transform="matrix(.86602 .5 -.86602 .5 501.2 181.82)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#lx)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 548.81 126.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#lw)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 463.24 159.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#lv)">
      <rect transform="matrix(.86602 .5 -.86602 .5 537.2 244.82)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#lu)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 584.81 189.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#lt)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 499.24 222.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#ls)">
      <rect transform="matrix(.86602 .5 -.86602 .5 501.2 307.82)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#lr)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 548.81 252.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#lq)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 463.24 285.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#lp)">
      <rect transform="matrix(.86602 .5 -.86602 .5 538.2 370.82)" width="67.733" height="120.43" fill="#047BFF" />
    </g>
    <g clipPath="url(#ln)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 585.81 315.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#lm)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 500.24 348.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#ll)">
      <rect transform="matrix(.86602 .5 -.86602 .5 828.2 -7.1798)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#lk)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 875.81 -62.877)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#lj)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 790.24 -29.096)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#li)">
      <rect transform="matrix(.86602 .5 -.86602 .5 792.2 55.82)" width="67.733" height="120.43" fill="#047BFF" />
    </g>
    <g clipPath="url(#lh)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 839.81 .12341)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#lg)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 754.24 33.904)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#lf)">
      <rect transform="matrix(.86602 .5 -.86602 .5 829.2 118.82)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#le)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 876.81 63.123)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#lc)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 791.24 96.904)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#lb)">
      <rect transform="matrix(.86602 .5 -.86602 .5 793.2 181.82)" width="67.733" height="120.43" fill="#047BFF" />
    </g>
    <g clipPath="url(#la)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 840.81 126.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#kz)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 755.24 159.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#ky)">
      <rect transform="matrix(.86602 .5 -.86602 .5 756.2 244.82)" width="67.733" height="120.43" fill="#047BFF" />
    </g>
    <g clipPath="url(#kx)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 803.81 189.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#kw)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 718.24 222.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#kv)">
      <rect transform="matrix(.86602 .5 -.86602 .5 719.2 307.82)" width="67.733" height="120.43" fill="#047BFF" />
    </g>
    <g clipPath="url(#ku)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 766.81 252.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#kt)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 681.24 285.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#kr)">
      <rect transform="matrix(.86602 .5 -.86602 .5 901.2 -7.1798)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#kq)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 948.81 -62.877)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#kp)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 863.24 -29.096)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#ko)">
      <rect transform="matrix(.86602 .5 -.86602 .5 865.2 55.82)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#kn)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 912.81 .12341)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#km)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 827.24 33.904)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#kl)">
      <rect transform="matrix(.86602 .5 -.86602 .5 902.2 118.82)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#kk)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 949.81 63.123)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#kj)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 864.24 96.904)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#ki)">
      <rect transform="matrix(.86602 .5 -.86602 .5 866.2 181.82)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#kg)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 913.81 126.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#kf)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 828.24 159.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#ke)">
      <rect transform="matrix(.86602 .5 -.86602 .5 829.2 244.82)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#kd)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 876.81 189.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#kc)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 791.24 222.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#kb)">
      <rect transform="matrix(.86602 .5 -.86602 .5 792.2 307.82)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#ka)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 839.81 252.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#jz)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 754.24 285.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#jy)">
      <rect transform="matrix(.86602 .5 -.86602 .5 902.2 244.82)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#jx)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 949.81 189.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#jv)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 864.24 222.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#ju)">
      <rect transform="matrix(.86602 .5 -.86602 .5 865.2 307.82)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#jt)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 912.81 252.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#js)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 827.24 285.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#jr)">
      <rect transform="matrix(.86602 .5 -.86602 .5 609.2 370.82)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#jq)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 656.81 315.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#jp)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 571.24 348.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#jo)">
      <rect transform="matrix(.86602 .5 -.86602 .5 682.2 370.82)" width="67.733" height="120.43" fill="#047BFF" />
    </g>
    <g clipPath="url(#jn)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 729.81 315.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#jm)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 644.24 348.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#jk)">
      <rect transform="matrix(.86602 .5 -.86602 .5 755.2 370.82)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#jj)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 802.81 315.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#ji)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 717.24 348.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#jh)">
      <rect transform="matrix(.86602 .5 -.86602 .5 828.2 370.82)" width="67.733" height="120.43" fill="#047BFF" />
    </g>
    <g clipPath="url(#jg)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 875.81 315.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#jf)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 790.24 348.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#je)">
      <rect transform="matrix(.86602 .5 -.86602 .5 901.2 370.82)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#jd)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 948.81 315.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#jc)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 863.24 348.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#jb)">
      <rect transform="matrix(.86602 .5 -.86602 .5 645.2 433.82)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#iz)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 692.81 378.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#iy)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 607.24 411.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#ix)">
      <rect transform="matrix(.86602 .5 -.86602 .5 682.2 496.82)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#iw)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 729.81 441.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#iv)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 644.24 474.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#iu)">
      <rect transform="matrix(.86602 .5 -.86602 .5 646.2 559.82)" width="67.733" height="120.43" fill="#047BFF" />
    </g>
    <g clipPath="url(#it)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 693.81 504.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#is)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 608.24 537.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#ir)">
      <rect transform="matrix(.86602 .5 -.86602 .5 682.2 622.82)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#iq)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 729.81 567.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#in)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 644.24 600.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#im)">
      <rect transform="matrix(.86602 .5 -.86602 .5 646.2 685.82)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#il)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 693.81 630.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#ik)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 608.24 663.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#ij)">
      <rect transform="matrix(.86602 .5 -.86602 .5 718.2 433.82)" width="67.733" height="120.43" fill="#047BFF" />
    </g>
    <g clipPath="url(#ii)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 765.81 378.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#ih)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 680.24 411.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#ig)">
      <rect transform="matrix(.86602 .5 -.86602 .5 755.2 496.82)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#if)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 802.81 441.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#ie)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 717.24 474.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#ic)">
      <rect transform="matrix(.86602 .5 -.86602 .5 719.2 559.82)" width="67.733" height="120.43" fill="#047BFF" />
    </g>
    <g clipPath="url(#ib)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 766.81 504.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#ia)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 681.24 537.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#hz)">
      <rect transform="matrix(.86602 .5 -.86602 .5 755.2 622.82)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#hy)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 802.81 567.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#hx)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 717.24 600.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#hw)">
      <rect transform="matrix(.86602 .5 -.86602 .5 719.2 685.82)" width="67.733" height="120.43" fill="#047BFF" />
    </g>
    <g clipPath="url(#hv)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 766.81 630.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#hu)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 681.24 663.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#ht)">
      <rect transform="matrix(.86602 .5 -.86602 .5 791.2 433.82)" width="67.733" height="120.43" fill="#047BFF" />
    </g>
    <g clipPath="url(#hr)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 838.81 378.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#hq)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 753.24 411.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#hp)">
      <rect transform="matrix(.86602 .5 -.86602 .5 828.2 496.82)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#ho)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 875.81 441.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#hn)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 790.24 474.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#hm)">
      <rect transform="matrix(.86602 .5 -.86602 .5 792.2 559.82)" width="67.733" height="120.43" fill="#047BFF" />
    </g>
    <g clipPath="url(#hl)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 839.81 504.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#hk)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 754.24 537.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#hj)">
      <rect transform="matrix(.86602 .5 -.86602 .5 828.2 622.82)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#hi)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 875.81 567.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#hg)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 790.24 600.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#hf)">
      <rect transform="matrix(.86602 .5 -.86602 .5 792.2 685.82)" width="67.733" height="120.43" fill="#047BFF" />
    </g>
    <g clipPath="url(#he)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 839.81 630.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#hd)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 754.24 663.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#hc)">
      <rect transform="matrix(.86602 .5 -.86602 .5 864.2 433.82)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#hb)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 911.81 378.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#ha)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 826.24 411.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#gz)">
      <rect transform="matrix(.86602 .5 -.86602 .5 865.2 559.82)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#gy)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 912.81 504.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#gx)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 827.24 537.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#gv)">
      <rect transform="matrix(.86602 .5 -.86602 .5 865.2 685.82)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#gu)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 912.81 630.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#gt)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 827.24 663.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#gs)">
      <rect transform="matrix(.86602 .5 -.86602 .5 390.2 496.82)" width="67.733" height="120.43" fill="#047BFF" />
    </g>
    <g clipPath="url(#gr)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 437.81 441.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#gq)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 352.24 474.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#gp)">
      <rect transform="matrix(.86602 .5 -.86602 .5 390.2 622.82)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#go)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 437.81 567.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#gn)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 352.24 600.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#gm)">
      <rect transform="matrix(.86602 .5 -.86602 .5 463.2 496.82)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#gk)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 510.81 441.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#gj)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 425.24 474.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#gi)">
      <rect transform="matrix(.86602 .5 -.86602 .5 427.2 559.82)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#gh)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 474.81 504.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#gg)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 389.24 537.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#gf)">
      <rect transform="matrix(.86602 .5 -.86602 .5 463.2 622.82)" width="67.733" height="120.43" fill="#047BFF" />
    </g>
    <g clipPath="url(#ge)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 510.81 567.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#gd)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 425.24 600.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#gc)">
      <rect transform="matrix(.86602 .5 -.86602 .5 427.2 685.82)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#gb)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 474.81 630.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#fz)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 389.24 663.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#fy)">
      <rect transform="matrix(.86602 .5 -.86602 .5 500.2 559.82)" width="67.733" height="120.43" fill="#047BFF" />
    </g>
    <g clipPath="url(#fx)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 547.81 504.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#fw)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 462.24 537.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#fv)">
      <rect transform="matrix(.86602 .5 -.86602 .5 536.2 622.82)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#fu)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 583.81 567.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#ft)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 498.24 600.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#fs)">
      <rect transform="matrix(.86602 .5 -.86602 .5 500.2 685.82)" width="67.733" height="120.43" fill="#047BFF" />
    </g>
    <g clipPath="url(#fr)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 547.81 630.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#fq)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 462.24 663.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#fo)">
      <rect transform="matrix(.86602 .5 -.86602 .5 609.2 496.82)" width="67.733" height="120.43" fill="#047BFF" />
    </g>
    <g clipPath="url(#fn)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 656.81 441.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#fm)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 571.24 474.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#fl)">
      <rect transform="matrix(.86602 .5 -.86602 .5 573.2 559.82)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#fk)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 620.81 504.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#fj)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 535.24 537.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#fi)">
      <rect transform="matrix(.86602 .5 -.86602 .5 609.2 622.82)" width="67.733" height="120.43" fill="#047BFF" />
    </g>
    <g clipPath="url(#fh)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 656.81 567.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#fg)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 571.24 600.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#ff)">
      <rect transform="matrix(.86602 .5 -.86602 .5 573.2 685.82)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#fd)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 620.81 630.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#fc)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 535.24 663.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#fb)">
      <rect transform="matrix(.86602 .5 -.86602 .5 500.2 811.82)" width="67.733" height="120.43" fill="#047BFF" />
    </g>
    <g clipPath="url(#fa)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 547.81 756.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#ez)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 462.24 789.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#ey)">
      <rect transform="matrix(.86602 .5 -.86602 .5 63.197 937.82)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#ex)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 110.81 882.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#ew)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 25.236 915.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#ev)">
      <rect transform="matrix(.86602 .5 -.86602 .5 27.197 1000.8)" width="67.733" height="120.43" fill="#047BFF" />
    </g>
    <g clipPath="url(#eu)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 74.813 945.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#es)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 -10.764 978.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#er)">
      <rect transform="matrix(.86602 .5 -.86602 .5 172.2 1000.8)" width="67.733" height="120.43" fill="#047BFF" />
    </g>
    <g clipPath="url(#eq)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 219.81 945.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#ep)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 134.24 978.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#eo)">
      <rect transform="matrix(.86602 .5 -.86602 .5 136.2 1063.8)" width="67.733" height="120.43" fill="#047BFF" />
    </g>
    <g clipPath="url(#en)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 183.81 1008.1)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#em)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 98.236 1041.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#el)">
      <rect transform="matrix(.86602 .5 -.86602 .5 62.197 1063.8)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#ek)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 109.81 1008.1)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#ej)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 24.236 1041.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#eg)">
      <rect transform="matrix(.86602 .5 -.86602 .5 99.197 874.82)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#ef)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 146.81 819.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#ee)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 61.236 852.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#ed)">
      <rect transform="matrix(.86602 .5 -.86602 .5 136.2 937.82)" width="67.733" height="120.43" fill="#047BFF" />
    </g>
    <g clipPath="url(#ec)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 183.81 882.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#eb)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 98.236 915.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#ea)">
      <rect transform="matrix(.86602 .5 -.86602 .5 100.2 1000.8)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#dz)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 147.81 945.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#dy)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 62.236 978.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#dx)">
      <rect transform="matrix(.86602 .5 -.86602 .5 245.2 1000.8)" width="67.733" height="120.43" fill="#047BFF" />
    </g>
    <g clipPath="url(#dv)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 292.81 945.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#du)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 207.24 978.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#dt)">
      <rect transform="matrix(.86602 .5 -.86602 .5 209.2 1063.8)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#ds)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 256.81 1008.1)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#dr)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 171.24 1041.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#dq)">
      <rect transform="matrix(.86602 .5 -.86602 .5 172.2 874.82)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#dp)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 219.81 819.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#do)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 134.24 852.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#dn)">
      <rect transform="matrix(.86602 .5 -.86602 .5 318.2 874.82)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#dm)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 365.81 819.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#dk)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 280.24 852.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#dj)">
      <rect transform="matrix(.86602 .5 -.86602 .5 209.2 937.82)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#di)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 256.81 882.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#dh)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 171.24 915.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#dg)">
      <rect transform="matrix(.86602 .5 -.86602 .5 318.2 1000.8)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#df)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 365.81 945.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#de)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 280.24 978.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#dd)">
      <rect transform="matrix(.86602 .5 -.86602 .5 282.2 1063.8)" width="67.733" height="120.43" fill="#047BFF" />
    </g>
    <g clipPath="url(#dc)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 329.81 1008.1)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#db)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 244.24 1041.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#cz)">
      <rect transform="matrix(.86602 .5 -.86602 .5 354.2 811.82)" width="67.733" height="120.43" fill="#047BFF" />
    </g>
    <g clipPath="url(#cy)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 401.81 756.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#cx)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 316.24 789.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#cw)">
      <rect transform="matrix(.86602 .5 -.86602 .5 391.2 874.82)" width="67.733" height="120.43" fill="#047BFF" />
    </g>
    <g clipPath="url(#cv)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 438.81 819.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#cu)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 353.24 852.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#ct)">
      <rect transform="matrix(.86602 .5 -.86602 .5 355.2 937.82)" width="67.733" height="120.43" fill="#047BFF" />
    </g>
    <g clipPath="url(#cs)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 402.81 882.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#cr)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 317.24 915.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#cq)">
      <rect transform="matrix(.86602 .5 -.86602 .5 391.2 1000.8)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#co)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 438.81 945.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#cn)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 353.24 978.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#cm)">
      <rect transform="matrix(.86602 .5 -.86602 .5 355.2 1063.8)" width="67.733" height="120.43" fill="#047BFF" />
    </g>
    <g clipPath="url(#cl)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 402.81 1008.1)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#ck)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 317.24 1041.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#cj)">
      <rect transform="matrix(.86602 .5 -.86602 .5 427.2 811.82)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#ci)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 474.81 756.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#ch)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 389.24 789.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#cg)">
      <rect transform="matrix(.86602 .5 -.86602 .5 464.2 874.82)" width="67.733" height="120.43" fill="#047BFF" />
    </g>
    <g clipPath="url(#cf)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 511.81 819.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#cd)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 426.24 852.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#cc)">
      <rect transform="matrix(.86602 .5 -.86602 .5 428.2 937.82)" width="67.733" height="120.43" fill="#002A58" />
    </g>
    <g clipPath="url(#cb)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 475.81 882.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#ca)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 390.24 915.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#bz)">
      <rect transform="matrix(.86602 .5 -.86602 .5 464.2 1000.8)" width="67.733" height="120.43" fill="#047BFF" />
    </g>
    <g clipPath="url(#by)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 511.81 945.12)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#bx)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 426.24 978.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <g clipPath="url(#bw)">
      <rect transform="matrix(.86602 .5 -.86602 .5 428.2 1063.8)" width="67.733" height="120.43" fill="#047BFF" />
    </g>
    <g clipPath="url(#bv)">
      <rect transform="matrix(2.203e-8 1 -.86602 .5 475.81 1008.1)" width="138.17" height="120.43" fill="#003875" />
    </g>
    <g clipPath="url(#bu)">
      <rect transform="matrix(.86602 .5 -2.203e-8 1 390.24 1041.9)" width="67.733" height="120.43" fill="#000F21" />
    </g>
    <defs>
      <clipPath id="mv">
        <rect transform="matrix(.86602 .5 -.86602 .5 545.85 756)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="io">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 582.42 777.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="eh">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 509.28 777.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="bo">
        <rect transform="matrix(.86602 .5 -.86602 .5 546.85 882)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="bd">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 583.42 903.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="as">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 510.28 903.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ah">
        <rect transform="matrix(.86602 .5 -.86602 .5 510.85 945)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="w">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 547.42 966.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="l">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 474.28 966.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="a">
        <rect transform="matrix(.86602 .5 -.86602 .5 546.85 1008)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="mk">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 583.42 1029.1)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="lz">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 510.28 1029.1)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="lo">
        <rect transform="matrix(.86602 .5 -.86602 .5 510.85 1071)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ld">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 547.42 1092.1)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ks">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 474.28 1092.1)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="kh">
        <rect transform="matrix(.86602 .5 -.86602 .5 547.85 1134)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="jw">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 584.42 1155.1)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="jl">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 511.28 1155.1)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ja">
        <rect transform="matrix(.86602 .5 -.86602 .5 582.85 819)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ip">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 619.42 840.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="id">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 546.28 840.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="hs">
        <rect transform="matrix(.86602 .5 -.86602 .5 618.85 756)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="hh">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 655.42 777.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="gw">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 582.28 777.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="gl">
        <rect transform="matrix(.86602 .5 -.86602 .5 619.85 882)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ga">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 656.42 903.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="fp">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 583.28 903.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="fe">
        <rect transform="matrix(.86602 .5 -.86602 .5 583.85 945)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="et">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 620.42 966.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ei">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 547.28 966.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="dw">
        <rect transform="matrix(.86602 .5 -.86602 .5 619.85 1008)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="dl">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 656.42 1029.1)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="da">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 583.28 1029.1)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="cp">
        <rect transform="matrix(.86602 .5 -.86602 .5 583.85 1071)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ce">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 620.42 1092.1)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="bt">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 547.28 1092.1)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="bs">
        <rect transform="matrix(.86602 .5 -.86602 .5 620.85 1134)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="br">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 657.42 1155.1)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="bq">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 584.28 1155.1)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="bp">
        <rect transform="matrix(.86602 .5 -.86602 .5 655.85 819)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="bn">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 692.42 840.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="bm">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 619.28 840.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="bl">
        <rect transform="matrix(.86602 .5 -.86602 .5 691.85 756)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="bk">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 728.42 777.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="bj">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 655.28 777.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="bi">
        <rect transform="matrix(.86602 .5 -.86602 .5 692.85 882)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="bh">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 729.42 903.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="bg">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 656.28 903.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="bf">
        <rect transform="matrix(.86602 .5 -.86602 .5 656.85 945)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="be">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 693.42 966.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="bc">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 620.28 966.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="bb">
        <rect transform="matrix(.86602 .5 -.86602 .5 692.85 1008)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ba">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 729.42 1029.1)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="az">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 656.28 1029.1)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ay">
        <rect transform="matrix(.86602 .5 -.86602 .5 656.85 1071)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ax">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 693.42 1092.1)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="aw">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 620.28 1092.1)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="av">
        <rect transform="matrix(.86602 .5 -.86602 .5 728.85 819)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="au">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 765.42 840.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="at">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 692.28 840.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ar">
        <rect transform="matrix(.86602 .5 -.86602 .5 764.85 756)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="aq">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 801.42 777.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ap">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 728.28 777.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ao">
        <rect transform="matrix(.86602 .5 -.86602 .5 765.85 882)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="an">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 802.42 903.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="am">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 729.28 903.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="al">
        <rect transform="matrix(.86602 .5 -.86602 .5 729.85 945)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ak">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 766.42 966.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="aj">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 693.28 966.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ai">
        <rect transform="matrix(.86602 .5 -.86602 .5 765.85 1008)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ag">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 802.42 1029.1)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="af">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 729.28 1029.1)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ae">
        <rect transform="matrix(.86602 .5 -.86602 .5 729.85 1071)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ad">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 766.42 1092.1)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ac">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 693.28 1092.1)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ab">
        <rect transform="matrix(.86602 .5 -.86602 .5 801.85 819)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="aa">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 838.42 840.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="z">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 765.28 840.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="y">
        <rect transform="matrix(.86602 .5 -.86602 .5 837.85 756)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="x">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 874.42 777.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="v">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 801.28 777.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="u">
        <rect transform="matrix(.86602 .5 -.86602 .5 838.85 882)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="t">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 875.42 903.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="s">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 802.28 903.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="r">
        <rect transform="matrix(.86602 .5 -.86602 .5 802.85 945)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="q">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 839.42 966.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="p">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 766.28 966.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="o">
        <rect transform="matrix(.86602 .5 -.86602 .5 838.85 1008)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="n">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 875.42 1029.1)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="m">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 802.28 1029.1)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="k">
        <rect transform="matrix(.86602 .5 -.86602 .5 802.85 1071)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="j">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 839.42 1092.1)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="i">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 766.28 1092.1)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="h">
        <rect transform="matrix(.86602 .5 -.86602 .5 764.85 0)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="g">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 801.42 21.114)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="f">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 728.28 21.113)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="e">
        <rect transform="matrix(.86602 .5 -.86602 .5 728.85 63)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="d">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 765.42 84.114)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="c">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 692.28 84.113)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="b">
        <rect transform="matrix(.86602 .5 -.86602 .5 765.85 126)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="mu">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 802.42 147.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="mt">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 729.28 147.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ms">
        <rect transform="matrix(.86602 .5 -.86602 .5 729.85 189)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="mr">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 766.42 210.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="mq">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 693.28 210.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="mp">
        <rect transform="matrix(.86602 .5 -.86602 .5 692.85 252)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="mo">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 729.42 273.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="mn">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 656.28 273.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="mm">
        <rect transform="matrix(.86602 .5 -.86602 .5 655.85 315)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ml">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 692.42 336.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="mj">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 619.28 336.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="mi">
        <rect transform="matrix(.86602 .5 -.86602 .5 619.85 252)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="mh">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 656.42 273.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="mg">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 583.28 273.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="mf">
        <rect transform="matrix(.86602 .5 -.86602 .5 583.85 315)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="me">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 620.42 336.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="md">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 547.28 336.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="mc">
        <rect transform="matrix(.86602 .5 -.86602 .5 583.85 189)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="mb">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 620.42 210.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ma">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 547.28 210.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ly">
        <rect transform="matrix(.86602 .5 -.86602 .5 510.85 189)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="lx">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 547.42 210.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="lw">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 474.28 210.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="lv">
        <rect transform="matrix(.86602 .5 -.86602 .5 546.85 252)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="lu">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 583.42 273.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="lt">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 510.28 273.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ls">
        <rect transform="matrix(.86602 .5 -.86602 .5 510.85 315)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="lr">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 547.42 336.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="lq">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 474.28 336.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="lp">
        <rect transform="matrix(.86602 .5 -.86602 .5 547.85 378)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ln">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 584.42 399.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="lm">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 511.28 399.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ll">
        <rect transform="matrix(.86602 .5 -.86602 .5 837.85 0)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="lk">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 874.42 21.114)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="lj">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 801.28 21.113)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="li">
        <rect transform="matrix(.86602 .5 -.86602 .5 801.85 63)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="lh">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 838.42 84.114)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="lg">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 765.28 84.113)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="lf">
        <rect transform="matrix(.86602 .5 -.86602 .5 838.85 126)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="le">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 875.42 147.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="lc">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 802.28 147.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="lb">
        <rect transform="matrix(.86602 .5 -.86602 .5 802.85 189)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="la">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 839.42 210.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="kz">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 766.28 210.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ky">
        <rect transform="matrix(.86602 .5 -.86602 .5 765.85 252)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="kx">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 802.42 273.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="kw">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 729.28 273.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="kv">
        <rect transform="matrix(.86602 .5 -.86602 .5 728.85 315)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ku">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 765.42 336.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="kt">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 692.28 336.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="kr">
        <rect transform="matrix(.86602 .5 -.86602 .5 910.85 0)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="kq">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 947.42 21.114)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="kp">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 874.28 21.113)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ko">
        <rect transform="matrix(.86602 .5 -.86602 .5 874.85 63)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="kn">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 911.42 84.114)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="km">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 838.28 84.113)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="kl">
        <rect transform="matrix(.86602 .5 -.86602 .5 911.85 126)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="kk">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 948.42 147.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="kj">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 875.28 147.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ki">
        <rect transform="matrix(.86602 .5 -.86602 .5 875.85 189)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="kg">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 912.42 210.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="kf">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 839.28 210.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ke">
        <rect transform="matrix(.86602 .5 -.86602 .5 838.85 252)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="kd">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 875.42 273.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="kc">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 802.28 273.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="kb">
        <rect transform="matrix(.86602 .5 -.86602 .5 801.85 315)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ka">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 838.42 336.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="jz">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 765.28 336.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="jy">
        <rect transform="matrix(.86602 .5 -.86602 .5 911.85 252)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="jx">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 948.42 273.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="jv">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 875.28 273.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ju">
        <rect transform="matrix(.86602 .5 -.86602 .5 874.85 315)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="jt">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 911.42 336.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="js">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 838.28 336.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="jr">
        <rect transform="matrix(.86602 .5 -.86602 .5 618.85 378)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="jq">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 655.42 399.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="jp">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 582.28 399.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="jo">
        <rect transform="matrix(.86602 .5 -.86602 .5 691.85 378)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="jn">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 728.42 399.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="jm">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 655.28 399.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="jk">
        <rect transform="matrix(.86602 .5 -.86602 .5 764.85 378)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="jj">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 801.42 399.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ji">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 728.28 399.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="jh">
        <rect transform="matrix(.86602 .5 -.86602 .5 837.85 378)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="jg">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 874.42 399.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="jf">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 801.28 399.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="je">
        <rect transform="matrix(.86602 .5 -.86602 .5 910.85 378)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="jd">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 947.42 399.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="jc">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 874.28 399.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="jb">
        <rect transform="matrix(.86602 .5 -.86602 .5 654.85 441)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="iz">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 691.42 462.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="iy">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 618.28 462.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ix">
        <rect transform="matrix(.86602 .5 -.86602 .5 691.85 504)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="iw">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 728.42 525.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="iv">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 655.28 525.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="iu">
        <rect transform="matrix(.86602 .5 -.86602 .5 655.85 567)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="it">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 692.42 588.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="is">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 619.28 588.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ir">
        <rect transform="matrix(.86602 .5 -.86602 .5 691.85 630)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="iq">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 728.42 651.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="in">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 655.28 651.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="im">
        <rect transform="matrix(.86602 .5 -.86602 .5 655.85 693)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="il">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 692.42 714.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ik">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 619.28 714.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ij">
        <rect transform="matrix(.86602 .5 -.86602 .5 727.85 441)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ii">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 764.42 462.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ih">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 691.28 462.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ig">
        <rect transform="matrix(.86602 .5 -.86602 .5 764.85 504)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="if">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 801.42 525.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ie">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 728.28 525.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ic">
        <rect transform="matrix(.86602 .5 -.86602 .5 728.85 567)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ib">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 765.42 588.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ia">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 692.28 588.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="hz">
        <rect transform="matrix(.86602 .5 -.86602 .5 764.85 630)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="hy">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 801.42 651.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="hx">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 728.28 651.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="hw">
        <rect transform="matrix(.86602 .5 -.86602 .5 728.85 693)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="hv">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 765.42 714.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="hu">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 692.28 714.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ht">
        <rect transform="matrix(.86602 .5 -.86602 .5 800.85 441)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="hr">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 837.42 462.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="hq">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 764.28 462.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="hp">
        <rect transform="matrix(.86602 .5 -.86602 .5 837.85 504)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ho">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 874.42 525.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="hn">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 801.28 525.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="hm">
        <rect transform="matrix(.86602 .5 -.86602 .5 801.85 567)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="hl">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 838.42 588.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="hk">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 765.28 588.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="hj">
        <rect transform="matrix(.86602 .5 -.86602 .5 837.85 630)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="hi">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 874.42 651.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="hg">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 801.28 651.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="hf">
        <rect transform="matrix(.86602 .5 -.86602 .5 801.85 693)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="he">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 838.42 714.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="hd">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 765.28 714.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="hc">
        <rect transform="matrix(.86602 .5 -.86602 .5 873.85 441)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="hb">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 910.42 462.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ha">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 837.28 462.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="gz">
        <rect transform="matrix(.86602 .5 -.86602 .5 874.85 567)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="gy">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 911.42 588.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="gx">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 838.28 588.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="gv">
        <rect transform="matrix(.86602 .5 -.86602 .5 874.85 693)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="gu">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 911.42 714.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="gt">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 838.28 714.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="gs">
        <rect transform="matrix(.86602 .5 -.86602 .5 399.85 504)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="gr">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 436.42 525.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="gq">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 363.28 525.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="gp">
        <rect transform="matrix(.86602 .5 -.86602 .5 399.85 630)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="go">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 436.42 651.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="gn">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 363.28 651.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="gm">
        <rect transform="matrix(.86602 .5 -.86602 .5 472.85 504)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="gk">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 509.42 525.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="gj">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 436.28 525.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="gi">
        <rect transform="matrix(.86602 .5 -.86602 .5 436.85 567)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="gh">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 473.42 588.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="gg">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 400.28 588.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="gf">
        <rect transform="matrix(.86602 .5 -.86602 .5 472.85 630)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ge">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 509.42 651.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="gd">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 436.28 651.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="gc">
        <rect transform="matrix(.86602 .5 -.86602 .5 436.85 693)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="gb">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 473.42 714.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="fz">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 400.28 714.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="fy">
        <rect transform="matrix(.86602 .5 -.86602 .5 509.85 567)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="fx">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 546.42 588.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="fw">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 473.28 588.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="fv">
        <rect transform="matrix(.86602 .5 -.86602 .5 545.85 630)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="fu">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 582.42 651.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ft">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 509.28 651.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="fs">
        <rect transform="matrix(.86602 .5 -.86602 .5 509.85 693)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="fr">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 546.42 714.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="fq">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 473.28 714.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="fo">
        <rect transform="matrix(.86602 .5 -.86602 .5 618.85 504)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="fn">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 655.42 525.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="fm">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 582.28 525.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="fl">
        <rect transform="matrix(.86602 .5 -.86602 .5 582.85 567)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="fk">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 619.42 588.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="fj">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 546.28 588.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="fi">
        <rect transform="matrix(.86602 .5 -.86602 .5 618.85 630)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="fh">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 655.42 651.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="fg">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 582.28 651.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ff">
        <rect transform="matrix(.86602 .5 -.86602 .5 582.85 693)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="fd">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 619.42 714.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="fc">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 546.28 714.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="fb">
        <rect transform="matrix(.86602 .5 -.86602 .5 509.85 819)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="fa">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 546.42 840.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ez">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 473.28 840.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ey">
        <rect transform="matrix(.86602 .5 -.86602 .5 72.852 945)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ex">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 109.42 966.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ew">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 36.281 966.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ev">
        <rect transform="matrix(.86602 .5 -.86602 .5 36.852 1008)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="eu">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 73.422 1029.1)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="es">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 .28125 1029.1)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="er">
        <rect transform="matrix(.86602 .5 -.86602 .5 181.85 1008)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="eq">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 218.42 1029.1)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ep">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 145.28 1029.1)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="eo">
        <rect transform="matrix(.86602 .5 -.86602 .5 145.85 1071)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="en">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 182.42 1092.1)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="em">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 109.28 1092.1)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="el">
        <rect transform="matrix(.86602 .5 -.86602 .5 71.852 1071)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ek">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 108.42 1092.1)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ej">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 35.281 1092.1)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="eg">
        <rect transform="matrix(.86602 .5 -.86602 .5 108.85 882)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ef">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 145.42 903.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ee">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 72.281 903.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ed">
        <rect transform="matrix(.86602 .5 -.86602 .5 145.85 945)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ec">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 182.42 966.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="eb">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 109.28 966.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ea">
        <rect transform="matrix(.86602 .5 -.86602 .5 109.85 1008)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="dz">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 146.42 1029.1)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="dy">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 73.281 1029.1)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="dx">
        <rect transform="matrix(.86602 .5 -.86602 .5 254.85 1008)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="dv">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 291.42 1029.1)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="du">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 218.28 1029.1)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="dt">
        <rect transform="matrix(.86602 .5 -.86602 .5 218.85 1071)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ds">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 255.42 1092.1)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="dr">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 182.28 1092.1)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="dq">
        <rect transform="matrix(.86602 .5 -.86602 .5 181.85 882)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="dp">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 218.42 903.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="do">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 145.28 903.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="dn">
        <rect transform="matrix(.86602 .5 -.86602 .5 327.85 882)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="dm">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 364.42 903.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="dk">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 291.28 903.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="dj">
        <rect transform="matrix(.86602 .5 -.86602 .5 218.85 945)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="di">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 255.42 966.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="dh">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 182.28 966.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="dg">
        <rect transform="matrix(.86602 .5 -.86602 .5 327.85 1008)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="df">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 364.42 1029.1)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="de">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 291.28 1029.1)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="dd">
        <rect transform="matrix(.86602 .5 -.86602 .5 291.85 1071)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="dc">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 328.42 1092.1)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="db">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 255.28 1092.1)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="cz">
        <rect transform="matrix(.86602 .5 -.86602 .5 363.85 819)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="cy">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 400.42 840.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="cx">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 327.28 840.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="cw">
        <rect transform="matrix(.86602 .5 -.86602 .5 400.85 882)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="cv">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 437.42 903.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="cu">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 364.28 903.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ct">
        <rect transform="matrix(.86602 .5 -.86602 .5 364.85 945)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="cs">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 401.42 966.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="cr">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 328.28 966.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="cq">
        <rect transform="matrix(.86602 .5 -.86602 .5 400.85 1008)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="co">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 437.42 1029.1)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="cn">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 364.28 1029.1)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="cm">
        <rect transform="matrix(.86602 .5 -.86602 .5 364.85 1071)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="cl">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 401.42 1092.1)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ck">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 328.28 1092.1)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="cj">
        <rect transform="matrix(.86602 .5 -.86602 .5 436.85 819)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ci">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 473.42 840.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ch">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 400.28 840.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="cg">
        <rect transform="matrix(.86602 .5 -.86602 .5 473.85 882)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="cf">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 510.42 903.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="cd">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 437.28 903.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="cc">
        <rect transform="matrix(.86602 .5 -.86602 .5 437.85 945)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="cb">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 474.42 966.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="ca">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 401.28 966.11)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="bz">
        <rect transform="matrix(.86602 .5 -.86602 .5 473.85 1008)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="by">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 510.42 1029.1)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="bx">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 437.28 1029.1)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="bw">
        <rect transform="matrix(.86602 .5 -.86602 .5 437.85 1071)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="bv">
        <rect transform="matrix(2.203e-8 1 -.86602 .5 474.42 1092.1)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
      <clipPath id="bu">
        <rect transform="matrix(.86602 .5 -2.203e-8 1 401.28 1092.1)" width="42.228" height="42.228" fill="#fff" />
      </clipPath>
    </defs>
  </svg>
);
